/* AcneEase redesign — scroll reveals + shop filters. Tier 0/1 only, no libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveals — once:true */
  var targets = document.querySelectorAll('.ae-rd [data-reveal]');
  if (!targets.length) return;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('rd-is-in');
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('rd-is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    for (var j = 0; j < targets.length; j++) io.observe(targets[j]);
  }

  /* Shop filters */
  var shop = document.querySelector('[data-ae-shop]');
  if (!shop) return;
  var buttons = shop.querySelectorAll('[data-filter]');
  var cards = shop.querySelectorAll('[data-cat]');
  var title = shop.querySelector('[data-shop-title]');
  var count = shop.querySelector('[data-shop-count]');

  function apply(filter, btn) {
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', String(buttons[i] === btn));
    }
    var shown = 0;
    for (var k = 0; k < cards.length; k++) {
      var match = filter === 'all' || cards[k].getAttribute('data-cat') === filter;
      cards[k].hidden = !match;
      if (match) shown++;
    }
    if (title && btn.getAttribute('data-title')) title.textContent = btn.getAttribute('data-title');
    if (count && btn.getAttribute('data-count')) {
      count.textContent = btn.getAttribute('data-count').replace('{n}', String(shown));
    }
  }

  for (var b = 0; b < buttons.length; b++) {
    buttons[b].addEventListener('click', function () {
      apply(this.getAttribute('data-filter'), this);
    });
  }

  /* Deep links: #acne / #beauty / #all preselect a filter */
  function fromHash() {
    var h = (location.hash || '').replace('#', '');
    if (!h) return;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-filter') === h) {
        apply(h, buttons[i]);
        return;
      }
    }
  }
  window.addEventListener('hashchange', fromHash);
  fromHash();
})();

/* ---------- product page: gallery, live variant price, sticky buy bar ---------- */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-ae-pdp]');
  if (!pdp) return;

  /* Gallery: crossfade the main image on thumb select. */
  var main = pdp.querySelector('#rd-pdp-main');
  var thumbs = pdp.querySelectorAll('.rd-pdp-thumb');
  for (var i = 0; i < thumbs.length; i++) {
    thumbs[i].addEventListener('click', function () {
      var btn = this;
      for (var k = 0; k < thumbs.length; k++) {
        thumbs[k].classList.toggle('rd-on', thumbs[k] === btn);
        thumbs[k].setAttribute('aria-pressed', String(thumbs[k] === btn));
      }
      if (!main) return;
      main.classList.add('rd-swap');
      var pre = new Image();
      pre.onload = function () {
        main.src = btn.getAttribute('data-full');
        main.srcset = btn.getAttribute('data-set') || '';
        main.alt = btn.getAttribute('data-alt') || '';
        main.classList.remove('rd-swap');
      };
      pre.onerror = function () { main.classList.remove('rd-swap'); };
      pre.src = btn.getAttribute('data-full');
    });
  }

  /* Variant select -> live price everywhere it is shown (buy box + sticky bar). */
  var prices = pdp.querySelectorAll('[data-pdp-price]');
  var unit = pdp.querySelector('[data-pdp-unit]');
  var radios = pdp.querySelectorAll('.rd-pdp-variant input[type=radio]');
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function () {
      var money = this.getAttribute('data-money');
      for (var q = 0; q < prices.length; q++) prices[q].textContent = money;
      if (!unit) return;
      var u = this.getAttribute('data-unit') || '';
      unit.textContent = u;
      unit.hidden = !u;
    });
  }

  /* Sticky mobile buy bar: reveal once the real Add to bag scrolls out of view. */
  var bar = pdp.querySelector('[data-pdp-sticky]');
  var anchor = pdp.querySelector('.rd-pdp-add');
  if (!bar || !anchor) return;
  if (!('IntersectionObserver' in window)) { bar.classList.add('rd-in'); return; }
  new IntersectionObserver(function (entries) {
    bar.classList.toggle('rd-in', !entries[0].isIntersecting);
  }, { rootMargin: '0px 0px -10px 0px', threshold: 0 }).observe(anchor);
})();

/* ---------- bag drawer: AJAX add-to-bag, quantity, totals ----------
   Progressive enhancement. With JS off the PDP/grid forms post natively to
   /cart/add and land on the styled /cart page, and the cart page's own
   /cart/change links still work. Nothing here is required to buy. */
(function () {
  'use strict';
  var dialog = document.querySelector('[data-ae-bag]');
  var holder = document.querySelector('[data-ae-bag-content]');
  var cfgEl = document.querySelector('[data-ae-bag-strings]');
  if (!dialog || !holder || !cfgEl || !dialog.showModal) return;

  var T;
  try { T = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  function money(cents) {
    return T.moneyPrefix + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function render(cart) {
    var bubbles = document.querySelectorAll('[data-ae-cart-count]');
    for (var i = 0; i < bubbles.length; i++) bubbles[i].textContent = cart.item_count;

    if (!cart.item_count) {
      holder.innerHTML =
        '<div class="rd-bag-empty"><h3>' + esc(T.emptyTitle) + '</h3><p>' + esc(T.emptyText) +
        '</p><button type="button" class="rd-button rd-primary" data-ae-bag-close><span>' +
        esc(T.continue) + '</span><span class="rd-arw" aria-hidden="true">↗</span></button></div>';
      return;
    }

    var lines = cart.items.map(function (it, idx) {
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? esc(it.variant_title) + ' · ' : '';
      return '<article class="rd-bag-line">' +
        '<img src="' + esc(sized(it.image, 220)) + '" alt="" width="75" height="85" loading="lazy">' +
        '<div><h3>' + esc(it.product_title) + '</h3>' +
        '<p>' + variant + money(it.original_price) + ' ' + esc(T.each) + '</p>' +
        '<div class="rd-line-bottom"><div class="rd-qty">' +
        '<button type="button" data-ae-line="' + (idx + 1) + '" data-ae-to="' + (it.quantity - 1) +
        '" aria-label="' + esc(T.decrease) + ' — ' + esc(it.product_title) + '">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-ae-line="' + (idx + 1) + '" data-ae-to="' + (it.quantity + 1) +
        '" aria-label="' + esc(T.increase) + ' — ' + esc(it.product_title) + '">+</button>' +
        '</div><span class="rd-line-price">' + money(it.final_line_price) + '</span></div></div></article>';
    }).join('');

    /* Discounts shown are the ones SHOPIFY applied - title and amount from /cart.js. */
    var discounts = (cart.cart_level_discount_applications || []);
    var savings = discounts.length
      ? '<div class="rd-bag-savings">' + discounts.map(function (d) { return esc(d.title); }).join(' · ') + '</div>'
      : '';
    var discountRows = discounts.map(function (d) {
      return '<div><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    }).join('');

    holder.innerHTML = lines + savings +
      '<div class="rd-totals"><div><span>' + esc(T.subtotal) + '</span><span>' +
      money(cart.items_subtotal_price) + '</span></div>' + discountRows +
      '<div class="rd-totals-total"><span>' + esc(T.total) + '</span><span>' +
      money(cart.total_price) + '</span></div></div>' +
      '<a class="rd-button rd-primary" href="/checkout"><span>' + esc(T.checkout) +
      '</span><span class="rd-arw" aria-hidden="true">↗</span></a>' +
      '<p class="rd-bag-note">' + esc(T.taxes) + '</p>' +
      '<button type="button" class="rd-text-link rd-bag-continue" data-ae-bag-close>' + esc(T.continue) + '</button>';
  }

  function refresh(open) {
    /* cartUrl is locale-aware ('/cart' or '/es/cart'); rootUrl has no trailing slash
       on secondary locales, so building from it produced '/escart.js'. */
    return fetch(T.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (open && !dialog.open) dialog.showModal();
        holder.setAttribute('aria-busy', 'false');
      })
      .catch(function () { holder.setAttribute('aria-busy', 'false'); });
  }

  /* Add to bag - intercept the real form so the native POST stays the fallback. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    fetch(T.addUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/javascript' }
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      holder.setAttribute('aria-busy', 'true');
      return refresh(true);
    }).catch(function () {
      form.submit();           /* fall back to the real page POST */
    }).then(function () {
      if (btn) btn.disabled = false;
    });
  });

  /* Quantity + remove, in the drawer and on the /cart page. */
  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-ae-bag-close]');
    if (close) { e.preventDefault(); dialog.close(); return; }

    var open = e.target.closest('[data-ae-cart-open]');
    if (open) { e.preventDefault(); holder.setAttribute('aria-busy', 'true'); refresh(true); return; }

    var step = e.target.closest('[data-ae-line],[data-ae-qty]');
    if (!step) return;
    var line = step.getAttribute('data-ae-line') || step.getAttribute('data-line');
    var to = step.getAttribute('data-ae-to') || step.getAttribute('data-to');
    if (line == null || to == null) return;
    e.preventDefault();
    holder.setAttribute('aria-busy', 'true');
    fetch(T.changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(to) })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        holder.setAttribute('aria-busy', 'false');
        /* On the cart page the server-rendered lines must reflect the change too. */
        if (!dialog.open) window.location.reload();
      })
      .catch(function () { window.location.href = step.href || T.cartUrl; });
  });

  /* Click outside the panel closes it, like the reference. */
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });
})();
